import { createApi, createBaseQuery } from '@adv-frontend/modules-query';
import { apiV1Request } from '#shared/api/requests';
import {
    getOpenApiGetProductVariantStocksUrl,
    getOpenApiUpdateProductVariantStocksUrl,
    OpenApiGetProductVariantStocksMethod,
    type OpenApiGetProductVariantStocksPathParameters,
    type OpenApiGetProductVariantStocksResponseSuccess,
    type OpenApiGetProductVariantStocksSearchParams,
    OpenApiUpdateProductVariantStocksMethod,
    type OpenApiUpdateProductVariantStocksRequest,
} from '#shared/api/schema';
import { invalidateProductGrids } from './api';

type GetProductVariantStocksArgs = {
    variantId: OpenApiGetProductVariantStocksPathParameters['product_variant_id'];
    searchParams: OpenApiGetProductVariantStocksSearchParams;
};

const productVariantStocksApi = createApi({
    name: 'entities/product/api/stocks',
    baseQuery: createBaseQuery(apiV1Request),
    endpoints: (builder) => {
        return {
            getStocks: builder.query<OpenApiGetProductVariantStocksResponseSuccess, GetProductVariantStocksArgs>({
                query: ({ variantId, searchParams }) => {
                    return {
                        url: getOpenApiGetProductVariantStocksUrl({
                            product_variant_id: encodeURIComponent(variantId),
                        }),
                        method: OpenApiGetProductVariantStocksMethod,
                        params: searchParams,
                        // Остатки изменяются независимо от карточки товара — не используем HTTP-кеш браузера.
                        headers: { 'Cache-Control': 'no-cache' },
                    };
                },
                // При повторном входе в раздел всегда читаем актуальный снимок с сервера.
                keepUnusedDataFor: 0,
            }),
            updateStocks: builder.mutation<null, { variantId: string; body: OpenApiUpdateProductVariantStocksRequest }>(
                {
                    async queryFn({ variantId, body }, _api, _options, baseQuery) {
                        const result = await baseQuery({
                            url: getOpenApiUpdateProductVariantStocksUrl({
                                product_variant_id: encodeURIComponent(variantId),
                            }),
                            method: OpenApiUpdateProductVariantStocksMethod,
                            body,
                        });

                        if (result.error) {
                            return { error: result.error };
                        }

                        invalidateProductGrids();

                        // Успешный PATCH не содержит тела; modules-query ожидает определённый data.
                        return { data: null };
                    },
                }
            ),
        };
    },
});

export const useLazyGetProductVariantStocksQuery = productVariantStocksApi.useLazyGetStocksQuery;
export const updateProductVariantStocks = productVariantStocksApi.endpoints.updateStocks.mutate;
